import { ReviewTypes, TableTypes } from "../../ManageContract/constants";
import { DASHBOARD_FEATURES } from "../../vscDashboard/constants";

export const adminManagementTabs = [
  {
    text: "Contract Review",
    disabled: false,
  },
  {
    text: DASHBOARD_FEATURES.TALK_TO_CONTRACT,
    disabled: false,
  },
  // {
  //   text: DASHBOARD_FEATURES.CLAUSE_CHECK,
  //   disabled: true,
  // },
];

export const manageContractTabs = [
  {
    text: ReviewTypes.PENDING_REVIEW,
    disabled: false,
  },
  {
    text: ReviewTypes.COMPLETED_REVIEW,
    disabled: false,
  },
];

const displayNames = {
  COMMITED_BUFFER: "Commited Buffer",
  PRODUCTIVITY_IMPROVEMENTS: "Productivity Improvements",
  SLA_PENALTY: "SLA Penalty/Earn back",
  VOLUME_DISCOUNTS: "Volume Discounts",
};

const ruleNames = {
  MIN_BENCH_POOL: "Bench Pool",
  MIN_CONTRACT_TERM: "Contract Term",
  PRODUCTIVITY_IMPROVEMENT: "Productivity Improvement (%)",
  MIN_CREDIT_CAP: "Credit Cap/Penalty",
  MIN_TOTAL_SPENDS: "Total Spends",
  MIN_DISCOUNT: "Discount",
};
export const ruleUnits = {
  PERCENT: "%",
  DOLLAR: "$",
  MONTHS: "months",
};

export const PromptManagementValidations = {
  CONTRACT_REVIEW: {
    [displayNames.COMMITED_BUFFER]: {
      rules: {
        [ruleNames.MIN_BENCH_POOL]: {
          unit: ruleUnits.PERCENT,
          max: 50,
          min: 0,
        },
      },
    },
    [displayNames.PRODUCTIVITY_IMPROVEMENTS]: {
      rules: {
        [ruleNames.MIN_CONTRACT_TERM]: {
          unit: ruleUnits.MONTHS,
          max: 120,
          min: 1,
        },
        [ruleNames.PRODUCTIVITY_IMPROVEMENT]: {
          unit: ruleUnits.PERCENT,
          max: 100,
          min: 0,
        },
      },
    },
    [displayNames.SLA_PENALTY]: {
      rules: {
        [ruleNames.MIN_CREDIT_CAP]: {
          unit: ruleUnits.PERCENT,
          max: 100,
          min: 1,
        },
      },
    },
    [displayNames.VOLUME_DISCOUNTS]: {
      rules: {
        [ruleNames.MIN_TOTAL_SPENDS]: {
          unit: ruleUnits.DOLLAR,
          max: 100000000,
          min: 0,
        },
        [ruleNames.MIN_DISCOUNT]: {
          unit: ruleUnits.PERCENT,
          max: 100,
          min: 1,
        },
      },
    },
  },
};
